// Unpublished Work © 2021-2022 Deere & Company

import t from 'tcomb';

export const SelectBusinessContact = t.struct({
    selectedContact: t.Number
}, {
    defaultProps: {
        selectedContact: 0
    },
    name: 'SelectBusinessContact',
    strict: true
});
